module.exports = __webpack_public_path__ + "static/media/bg.100f92c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/NewTimeline/assets/bg.svg
// module id = 268
// module chunks = 0